module.exports = __webpack_public_path__ + "static/media/a+classes.2a569b64.png";